import { render, staticRenderFns } from "./PickUpRecord.vue?vue&type=template&id=1e318fc0&scoped=true&"
import script from "./PickUpRecord.vue?vue&type=script&lang=js&"
export * from "./PickUpRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e318fc0",
  null
  
)

export default component.exports